export const environment = {
  production: false,
  coreApiUrl: 'https://portal-test.goatness.app/api',
  coachPortalUrl: 'https://portal-test.goatness.app',
  authorityApiUrl: 'https://login-test.goatness.app/api',
  authorityPortalUrl: 'https://login-test.goatness.app/',
  clientAppUrl: 'goatsports://',
  sentryDSN: 'https://689b988150f2b74be90ea8595f5bcb15@o4507419812102144.ingest.de.sentry.io/4507419815313488',
  sentryEnvironment: 'test'
};
